import React, { useEffect, useState } from 'react';
import { post } from '../../Auths/AuthToken';
import BenifitInformation from './BenifitInformation';
import EligibilityReportSummary from './EligibilityReportSummary';
import setUiMessage from '../../../Utilities/Tostify';

const ViewReportEligibilityPopup = ({
  eligId,
  patFullname,
  patId,
  patDob,
  patYearGen,
  setViewReportEligibilityPopup,
  hideFutreApp = false,
}) => {
  const [viewReportData, setViewReportData] = useState('');
  const [activeEligibilityTab, setActiveEligibilityTab] = useState(true);
  const [activeBenefitTab, setActiveBenefitTab] = useState(false);
  const [coverBenefits, setCoverBenefits] = useState('');
  const [acord, setAcord] = useState(0);
  const [errorCode, setErrorCode] = useState([]);
  const handleEligibilityAvtiveTab = () => {
    setActiveEligibilityTab(true);
    setActiveBenefitTab(false);
  };
  const handleBenefitAvtiveTab = () => {
    setActiveEligibilityTab(false);
    setActiveBenefitTab(true);
  };

  useEffect(() => {
    (async () => {
      try {
        const response = await post(
          'api/appointment/Appointment/openEligDetailPopUp',
          {
            eligId: eligId,
          }
        );

        if (response?.status === 200) {
          setViewReportData(response?.data?.eligibilityData);
          setCoverBenefits(response?.data?.coverbenefits);
          setErrorCode(response?.data?.error);
        }
      } catch (err) {}
    })();
  }, [eligId]);

  const handleAcordion = (key) => {
    setAcord(key);
  };

  const handlePrint = async () => {
    try {
      const response = await post(
        'api/appointment/Appointment/printEligibilityReport',
        { ediReqId: eligId }
      );
      if (response?.status === 200) {
        if (response.data?.status === 'success') {
          const pdfUrl = response.data?.pdfFileName;
          if (pdfUrl) {
            const popupWindow = window.open(
              pdfUrl,
              '',
              'height=800,width=750,resizable=0,fullscreen=0,titlebar=0,menubar=0,toolbar=0,status=0,scrollbars=1'
            );

            if (popupWindow) {
              popupWindow.onload = function () {
                popupWindow.focus();
                popupWindow.print();
              };
            } else {
              setUiMessage(
                'err',
                'Popup blocked! Please check if your browser is blocking popups.'
              );
            }
          } else {
            console.error('PDF URL is not defined.');
          }
        } else if (response.data?.status === 'pdffail') {
          setUiMessage('err', 'PDF file not generated');
        } else {
          setUiMessage('err', 'Print for Eligibility report summary failed.');
        }
      }
    } catch (error) {
      setUiMessage('err', error?.message);
    }
  };

  return (
    <div className="modalBackground">
      <div
        className="main-contnr"
        style={{ width: '800px', padding: '0px 15px 15px', height: '600px' }}
      >
        <div className="appt-hx-hdr-pt-info">
          <span className="rc-pt-nm">
            {patFullname} <span className="red">|</span> ID:
            {patId}
            <span className="red"> | </span> {patYearGen}
            <span className="red"> | </span> Dob:{patDob}
          </span>
          <span
            className="right red bold"
            onClick={() => setViewReportEligibilityPopup(false)}
          >
            X
          </span>
        </div>
        <div className="appt-hx-hdr tab-bg">
          <span
            className={
              activeEligibilityTab
                ? 'menu-item menu-item-active'
                : 'menu-item link-color'
            }
            onClick={handleEligibilityAvtiveTab}
            style={{ height: '475px' }}
          >
            Eligibility report summary
          </span>
          {!hideFutreApp && (
            <span
              className={
                activeBenefitTab
                  ? 'menu-item menu-item-active'
                  : 'menu-item link-color'
              }
              onClick={handleBenefitAvtiveTab}
            >
              Benefit information
            </span>
          )}
        </div>
        <div
          className={
            activeEligibilityTab ? 'appt-hx-pc-body' : 'appt-hx-pc-body hide'
          }
          style={{ height: '475px', overflowY: 'auto' }}
        >
          <EligibilityReportSummary viewReportData={viewReportData} />
        </div>
        <div
          className={
            activeBenefitTab ? 'appt-hx-fa-body' : 'appt-hx-fa-body hide'
          }
          style={{ height: '475px', overflowY: 'auto' }}
        >
          {errorCode && errorCode.length > 0 ? (
            // Render error content if errorCode has length greater than 0
            <>
              {errorCode.map((error, index) => (
                <div key={index}>
                  {error.errorDescLoop ? (
                    //This will run when errorDescLoop is not Empty
                    <div class="left width100 center maroon fontsize16 clear-top ">
                      <p>
                        <b>Loop: </b>
                        {error.errorLoop}&nbsp;&nbsp; <b>Error Code: </b>
                        {error.errorCode}&nbsp;&nbsp; <b>Message: </b>
                        {error.errorDescLoop}
                      </p>
                    </div>
                  ) : (
                    //This will run when errorDescLoop is Empty
                    <div class="left width100 center maroon fontsize16 clear-top ">
                      <p>
                        <b>Loop: </b>
                        {error.errorLoop}&nbsp;&nbsp; <b>Error Code: </b>
                        {error.errorCode}&nbsp;&nbsp; <b>Message: </b>
                        {error.errorDesc}
                      </p>
                    </div>
                  )}
                </div>
              ))}
            </>
          ) : (
            <>
              {coverBenefits &&
                Object.keys(coverBenefits).map((ele, key) => (
                  <div key={key}>
                    <BenifitInformation
                      ele={ele}
                      myKey={key}
                      handleAcordion={handleAcordion}
                      accord={acord}
                      coverBenefits={coverBenefits}
                    />
                  </div>
                ))}
            </>
          )}
        </div>
        <div className="bill-claim-edit-btn-rw">
          <div
            id="eligPopUpCancel"
            className="actn-No clear-right right"
            onClick={() => setViewReportEligibilityPopup(false)}
          >
            Close
          </div>
          <div
            id="eligPopUpSave"
            className="actn-yes clear-right right"
            onClick={handlePrint}
          >
            Print
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewReportEligibilityPopup;
